import React from "react";
import { useEffect } from "react";
import { useMemo } from "react";
import { createContext, useState } from "react";
import query from "../server/constants.api";
import useMultipleFetch from "../server/useMultipleFetch";
import io from 'socket.io-client';
import { websocketPort } from '../server/websocketPort';

export const ConfigContext = createContext();

export const useConfigContext = () => {
    const context = React.useContext(ConfigContext);

    if (!context) {
        throw new Error("useLangContext must be used within an LanguageProvider");
    }
    return context;
};

export const ConfigProvider = (props) => {
    const queryResults = useMultipleFetch([
        { path: query.path.globalConfiguration, id: 'getOverwallconfiguration' }
        // { path: query.path.layoutZonaD, id: 'getLayoutZonaD' }
    ]);
    const [currentConfig, setCurrentConfig] = useState({});
    const [socket, setSocket] = useState(null);
    const [zoneConfig, setZoneConfig] = useState({
        zoneA: { visible: true, name: 'Zone A', testMode: false },
        zoneB: { visible: true, name: 'Zone B', testMode: false },
        zoneC: { visible: true, name: 'Zone C', testMode: false },
        zoneX: { visible: true, name: 'Zone X', testMode: false },
        zoneZ: { visible: true, name: 'Zone Z', testMode: false },
        zoneD: { visible: false, name: 'Zone D', testMode: false }
    });

    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight
    });

    useEffect(() => {
        const handleResize = () => {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight
            });
        };

        // Adiciona o ouvinte de resize
        window.addEventListener('resize', handleResize);

        // Limpeza do ouvinte quando o componente for desmontado
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // WebSocket connection for real-time updates
    useEffect(() => {
        const socketInstance = io(websocketPort, {
            transports: ['websocket'],
            reconnection: true,
            reconnectionDelay: 1000,
            reconnectionAttempts: 5
        });

        socketInstance.on('connect', () => {
            console.log('ConfigContext: Connected to WebSocket server:', websocketPort);
        });

        socketInstance.on('disconnect', () => {
            console.log('ConfigContext: Disconnected from WebSocket server');
        });

        socketInstance.on('update_zone_config', (config) => {
            console.log('ConfigContext: Received zone config update:', config);
            setZoneConfig(config);
        });

        socketInstance.on('test_signal', (data) => {
            console.log('ConfigContext: Received test signal:', data);
        });

        setSocket(socketInstance);

        return () => {
            socketInstance.disconnect();
        };
    }, []);

    // useEffect(() => {
    //     if (queryResults[0]?.data?.data) {
    //         const result = queryResults[0]?.data?.data;
    //         if (result?.layoutZonaD === true) {
    //             setCurrentConfig(prev => ({
    //                 ...prev,
    //                 LayoutZonaD: queryResults[1]?.data?.data
    //             }));
    //         }
    //     }
    // }, [queryResults[0]?.data?.data, queryResults[1]?.data?.data]);

    const value = useMemo(() => {
        return { currentConfig, windowSize, zoneConfig, setZoneConfig, socket };
    }, [currentConfig, windowSize, zoneConfig, socket]);

    return <ConfigContext.Provider value={value}>{props.children}</ConfigContext.Provider>
}